import React, { useEffect, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Stats from 'frontend_stats';
import {
	Buttons,
	FacebookBtn,
	GoogleBtn,
	Text,
	IconWrapper,
} from './socialButtonsStyles';

// Import icons individually for better code splitting
import Facebook from 'core/icons/Facebook';
import Google from 'core/icons/Google';
import Spinner from 'core/components/Spinner';
import { getColor } from 'core/utils/Styles';

// Number of seconds after button press to reset state of button
const SECONDS_TO_RESET = 15;

const SocialButtons = ({ facebookClick, googleClick, signUp }) => {
	const [loading, setLoading] = useState(null);
	const [timeoutId, setTimeoutId] = useState(null);
	const [showFacebook, setShowFacebook] = useState(true);

	useEffect(() => {
		if (window?.cj?.adultContent) {
			setShowFacebook(false);
		}
	}, []);

	const handleClick = useCallback((e, network, cb) => {
		if (loading === network) return; // avoid double-click
		setLoading(network);
		cb(e);
		// This is a fallback in case user closes the auth popup window or
		// In case of error, reset state eventually to let them try again...
		timeoutId && clearTimeout(timeoutId);
		setTimeoutId(
			setTimeout(() => {
				Stats.trackGeneric('reset_social_btns', {
					step_name: 'loading'
				});
				setLoading(null);
			}, (SECONDS_TO_RESET * 1000))
		);
	}, [loading, timeoutId]);

	return (
		<Buttons>
			{showFacebook ? (
				<FacebookBtn onClick={e => handleClick(e, 'facebook', facebookClick)}>
					<IconWrapper>
						<Facebook />
					</IconWrapper>
					{loading === 'facebook' && (
						<Spinner color={getColor('facebook')} />
					)}
					{/*
					<Text/> be rendered when hidden (diplay:none)
					Otherwise the core/hoc/Toggle registers clicks on this as outside click
					Which would close the LoginBubble
				*/}
					<Text style={{ display: loading === 'facebook' ? 'none' : null }}>
					Sign {signUp ? 'up' : 'in'}
					</Text>
				</FacebookBtn>
			) : (
				<FacebookBtn as="a" href="/login">
					{/*
					Facebook will disable Platform JS if we serve their code on "adult content" pages
					To avoid that, we just don't serve their JS on those pages and direct to /login instead
				*/}
					<Text>
					Social Login
					</Text>
				</FacebookBtn>
			)}

			<GoogleBtn onClick={e => handleClick(e, 'google', googleClick)}>
				<IconWrapper>
					<Google />
				</IconWrapper>
				{loading === 'google' && (
					<Spinner color={getColor('google')} />
				)}
				{/*
					<Text/> be rendered when hidden (diplay:none)
					Otherwise the core/hoc/Toggle registers clicks on this as outside click
					Which would close the LoginBubble
				*/}
				<Text style={{ display: loading === 'google' ? 'none' : null }}>
					Sign {signUp ? 'up' : 'in'}
				</Text>
			</GoogleBtn>
		</Buttons>
	);
};

SocialButtons.propTypes = {
	facebookClick: PropTypes.func,
	googleClick: PropTypes.func,
	signUp: PropTypes.bool,
};

export default SocialButtons;
